import React from "react";
import ApiPortalLayout from "./ApiPortalLayout";

// ──────────────────────────────────────────────
// DataPolicyPage.jsx — 데이터 이용 정책(무단 수집 금지) (?page=data-policy, 2026-10-13)
//   이용약관은 DocuAI 사이트(docuai.tlogin.net/termsOfUse)에 있어 loginHS 데이터 이용 원칙을 따로 싣는다.
//   보호 대상은 '우리가 수집·가공·편집한 데이터베이스'다 — 관세청 원문 자료 자체를 우리 것이라 하지 않는다.
// ──────────────────────────────────────────────

const INK = "#16151a";
const BODY = "#374151";
const MUTED = "#6b7280";
const LINE = "#ecedf2";

const H = ({ children }) => <h2 style={{ fontSize: 17, fontWeight: 800, color: INK, margin: "28px 0 8px" }}>{children}</h2>;
const P = ({ children }) => <p style={{ fontSize: 14, color: BODY, lineHeight: 1.8, margin: "0 0 8px" }}>{children}</p>;
const L = ({ items }) => (
  <ul style={{ margin: "0 0 8px", paddingLeft: 20, fontSize: 14, color: BODY, lineHeight: 1.8 }}>
    {items.map((t) => <li key={t}>{t}</li>)}
  </ul>
);

export default function DataPolicyPage({ onNavigate }) {
  return (
    <ApiPortalLayout active="data-policy" onNavigate={onNavigate}>
      <article data-testid="data-policy" style={{ maxWidth: 820 }}>
        <h1 style={{ fontSize: 26, fontWeight: 800, color: INK, margin: "4px 0 6px" }}>데이터 이용 정책</h1>
        <div style={{ fontSize: 13, color: MUTED, marginBottom: 6 }}>시행 2026-10-13 · (주)로그인네트웍</div>
        <P>
          이 정책은 LoginHS(loginhs.co.kr · loginhs.tlogin.net)가 제공하는 데이터의 보호와 이용 범위를 정합니다.
          회원 가입·결제 등 서비스 이용 전반에 관한 사항은 이용약관을 따릅니다.
        </P>

        <H>1. 보호 대상</H>
        <P>
          LoginHS 의 세번 분류 결과, 분류사례 정리·요약·연결, 관세사 신고 이력 통계, 결정트리·갈림 질문, 화면 구성은
          (주)로그인네트웍이 상당한 투자로 수집·가공·편집한 데이터베이스입니다. 이는 저작권법(데이터베이스제작자의 권리)과
          부정경쟁방지 및 영업비밀보호에 관한 법률(데이터 부정사용 금지)의 보호를 받습니다.
        </P>
        <P>
          관세청·국가법령정보센터 등이 공개한 원문 자료 자체는 각 기관의 공공 자료입니다. LoginHS 는 그 원문으로 연결하며,
          원문 자료에 대한 권리를 주장하지 않습니다.
        </P>

        <H>2. 금지하는 행위</H>
        <L items={[
          "스크래핑·크롤링·봇·자동화 스크립트 등으로 화면이나 API 응답을 대량으로 수집하는 행위",
          "수집한 데이터를 복제·저장·가공하여 다른 서비스·데이터베이스·학습 자료로 쓰거나 재배포·판매하는 행위",
          "공유 링크·계정·API 키를 이용해 정해진 범위를 넘어 데이터를 내려받는 행위",
          "접근 제한·요청 한도·로그인 등 보호 장치를 우회하는 행위",
        ]} />

        <H>3. 허용하는 이용</H>
        <L items={[
          "회원 본인의 업무를 위해 화면에서 조회·확인하는 것",
          "공유 기능으로 특정 결과·메모·사례를 업무 상대에게 보내는 것",
          "업무 문서에 결과를 인용하면서 출처(LoginHS)를 밝히는 것",
          "시스템 연동이 필요할 때 공개 API(키 발급, 이용 한도 안)로 받는 것",
        ]} />

        <H>4. 위반 시 조치</H>
        <P>
          위 금지 행위가 확인되면 사전 통지 없이 접속·계정·API 키를 제한하거나 해지할 수 있으며, 관련 법령에 따라
          손해배상 청구 등 민·형사상 책임을 물을 수 있습니다.
        </P>

        <H>5. 문의</H>
        <P>
          데이터 연동·제휴·대량 이용은 문의하기 또는 연락처(032-744-6000)로 알려 주세요. 공개 API 안내는{" "}
          <a href="/?page=api-docs" onClick={(e) => { if (onNavigate) { e.preventDefault(); onNavigate("api-docs"); } }} style={{ color: "#1a56db" }}>API 문서</a>에 있습니다.
        </P>
        <div style={{ borderTop: `1px solid ${LINE}`, marginTop: 24, paddingTop: 12, fontSize: 12, color: MUTED }}>
          (주)로그인네트웍 · 사업자등록번호 121-86-03351 · 인천광역시 중구 화랑목로 40-8 (운서동) 102·103·104호
        </div>
      </article>
    </ApiPortalLayout>
  );
}
